export const metadata = {
    attribute: { attribute: true },
    nonSensitive: { nonSensitive: true },
    recordId: { recordId: true, nonSensitive: true },
    groupId: { groupId: true, nonSensitive: true },
    disableLogs: (opts: { access?: boolean; audit?: boolean }) => ({
        disableAccessLog: opts.access === true,
        disableAuditLog: opts.audit === true,
    }),
};
